import { PrintLabelSmallPage } from "@/features/print-label/pages/PrintLabelSmallPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/print-label/small")({
	component: PrintLabelSmallPage,
});
